import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Routes from './routes';
import { ThemeProvider, ToastProvider } from '@locus-taxy/neo-ui';
import { LocusApiModel } from 'common/modules/api';
import { AuthenticationActions } from 'common/modules/auth';

import storeConfig from './storeProvider';
import i18n from '../i18n';
import { I18nextProvider } from 'react-i18next';
import { QueryClientProvider } from 'react-query';
import queryClient from 'common/middleware/queryClient';
import setupEventNotificationService from './setupEventNotificationService';

const { store, persistor } = storeConfig;

setupEventNotificationService(store);

LocusApiModel.set401Interceptor((request, response) => {
    return new Promise(resolve => {
        store.dispatch(
            AuthenticationActions.logout({
                returnTo: window.location.href
            })
        );
        resolve(response);
    });
});

class Root extends Component {
    render() {
        return (
            <ThemeProvider>
                <ToastProvider>
                    <I18nextProvider i18n={i18n}>
                        <QueryClientProvider client={queryClient}>
                            <Provider store={store}>
                                <PersistGate
                                    loading={null}
                                    persistor={persistor}
                                >
                                    <Routes />
                                </PersistGate>
                            </Provider>
                        </QueryClientProvider>
                    </I18nextProvider>
                </ToastProvider>
            </ThemeProvider>
        );
    }
}

export default Root;
